export default __webpack_public_path__ + "static/media/GymTonicWalkingSpeed.15e70568.png";